import logo from './logo.svg';
import './App.css';
import Home from './Pages/Home';
import DocumentClaimScreen from './Pages/DocumentClaimScreen';
import ReportScreen from './Pages/ReportScreen';
import { Navigate, Route, Routes } from 'react-router-dom';
import React, { useEffect, useState } from "react";
import Unauthorize from './Pages/Unauthorize';
import { UserContext } from './Hook/UserContext';
import Login from './Pages/Login';
import axios from 'axios';
import AppInsight from './AppInsight';
import IntermediateFormScreen from './Pages/IntermediateForm';
import { useParams } from 'react-router-dom';
import { getCookie, setCookie, getAccessToken, parseJwt } from './common';
import { Alert } from 'bootstrap/dist/js/bootstrap.bundle';

function App() {
  let userRole = 0;
  const [code,setCode] = useState('');
  const userInfoData = JSON.parse(getCookie('userInfo'));
  const extractRoleName=getCookie('roleName');
  // console.log("extractRoleName",extractRoleName);
    if (extractRoleName?.includes(process.env.REACT_APP_SECURE_GROUP_ADMIN)) {
      userRole=1;
    } else if (extractRoleName?.includes(process.env.REACT_APP_SECURE_GROUP_AUDITOR)) {
      userRole=2;
    }
    else if (extractRoleName?.includes(process.env.REACT_APP_SECURE_GROUP_AUDITOR_OFFSHORE)) {
      userRole=4;
    } else if (extractRoleName?.includes(process.env.REACT_APP_SECURE_GROUP_ADMIN_OFFSHORE)) {
      userRole=3;
    } else {
      userRole=0;
    }
   


  return (
    <UserContext.Provider value={{userRole,code,setCode}}>
      {((code === null || code === '') && (getCookie('authPassAcessTokenInfo') === '' || getCookie('authPassAcessTokenInfo') === null)) ?
        (
          <Routes>
            <Route path="/" exact element={<Login />}></Route>
            <Route path="/login" element={<Login />}></Route>
            <Route path="*" element={<Login />}></Route>
          </Routes>
        ) :
        (
          (userRole > 0 ?
            (
              <Routes>
                <Route exact path="/" element={<Home />} />
                <Route exact path="/home" element={<Home />} />
                <Route exact path="/DocumentClaimScreen/:pkey" element={<DocumentClaimScreen />} />
                <Route exact path="/DocumentClaimScreen" element={<DocumentClaimScreen />} />
                <Route exact path="/ReportScreen" element={<ReportScreen />} />
                <Route exact path="/IntermediateFormScreen" element={<IntermediateFormScreen />} />
              </Routes>
            ) :
            (<Routes>
              <Route exact path="*" element={<Unauthorize />} />
            </Routes>)
          ))

      }
    </UserContext.Provider>
  );
}
export default App;
